<template>
  <a-menu
    :selectedKeys="stateSelectedKeys"
    mode="horizontal"
    @click="handleMenuClick"
  >
    <template v-for="barItem in stateMenuList">
      <!-- <a-sub-menu
        v-if="barItem.menuList"
        :key="barItem.title"
        @titleClick="(e) => handleSubMenClick(e, barItem)"
      >
        <span slot="title">
          <span
            v-if="stateSelectedKeys.includes(barItem.title)"
            :key="barItem.title"
            class="selected-menu"
            >{{ barItem.title }}</span
          >
          <span>{{ barItem.title }}</span>
        </span>
        <a-menu-item v-for="item in barItem.menuList" :key="item.title">{{
          item.title
        }}</a-menu-item>
      </a-sub-menu> -->
      <a-menu-item :key="barItem.title">
        <!-- <span v-if="stateSelectedKeys.includes(barItem.title)" :key="barItem.title" class="selected-menu">{{barItem.title}}</span> -->
        <div class="menu-title-wrap">
          <div class="title-item">{{ barItem.title }}</div>
          <div
            v-if="!stateSelectedKeys.includes(barItem.title)"
            class="title-after-line"
          ></div>
        </div>
      </a-menu-item>
    </template>
  </a-menu>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { ROUTER_MAP } from '../configs/menuRouter';
import { productDataBase, geIntegrationToken, geSZIntegrationToken } from '@/api/competitor';
import qs from 'qs'

export default {
  data() {
    return {};
  },
  created() {},
  computed: {
    ...mapGetters('headerMenu', [
      'stateMenuList',
      'stateSelectedKeys',
      'stateRouterPath',
    ]),
  },
  mounted() {},
  methods: {
    ...mapMutations('headerMenu', ['updateMenuItemStatus']),
    menuOperation(keyPath, key) {
      const routerPath = ROUTER_MAP[key];
      if (routerPath === 'industryData') {
        productDataBase().then((res) => {
          const { access_token } = res.data;
          const { refresh_token } = res.data;
          window.open(
            `${window.APP_NAME.BASE_URL}?token=${access_token}&refresh_token=${refresh_token}`
          );
          // window.open(`http://localhost:8083?token=${access_token}&refresh_token=${refresh_token}`)
        });
      } else if(routerPath === 'patyee') {
        // window.open('http://www.patyee.com/', '_blank');
        geSZIntegrationToken().then((res) => {
          if (res.code === 200) {
            // url参数
            const params = {
              access_token: res.data.access_token,
              refresh_token: res.data.refresh_token,
              token_type: res.data.token_type,
              expires_in: res.data.expires_in
            }
            let ipiIndex = 'http://xcl.ourchem.com/fvue/'
            ipiIndex = `${ipiIndex.split('mzscjd').join(params.tenantCode)}thirdToken`
            const ipiUrl = `${ipiIndex}?${qs.stringify(params)}`
            window.open(ipiUrl)
          } else {
            this.$router.push({ path: '/login' })
          }
        })
      } else if (routerPath === 'patentTopic') {
        geIntegrationToken().then((res) => {
          // url参数
          const params = {
            // type: 'email',
            tenantCode: 'mzscjd',
            pageType: 'thematicDatabase',
            redirect: '/patyeeResults/list',
            expiredIn: res.expiredIn,
            access_token: res.token,
            refresh_token: res.refreshToken
          }
          let ipiIndex = 'https://mzscjd.ipsunlight.com/fvue'
          ipiIndex = `${ipiIndex.split('mzscjd').join(params.tenantCode)}thirdToken`
          const ipiUrl = `${ipiIndex}?${qs.stringify(params)}`
          window.open(ipiUrl)
        })
      } else {
        this.$router.push({ path: `/${routerPath}` });
      }
    },
    handleMenuClick(instance) {
      console.log(instance);
      const { keyPath, key } = instance;
      console.log(keyPath);
      if (keyPath) {
        // 如果是下拉框的情况，会不存在keypath，所以需要过滤掉
        this.menuOperation(keyPath, key);
      }
    },
    handleSubMenClick(instance, listInstance) {
      const { key } = instance;
      const { menuList } = listInstance;
      const keyPath = [key, menuList[0].title]; // 默认选中第一个
      this.menuOperation(keyPath, key);
    },
  },
};
</script>
